var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 96,
    viewBox: "0 0 108 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4381 3.15602L107.259 87.7185C107.709 88.4976 107.945 89.3814 107.945 90.281C107.946 91.1806 107.709 92.0644 107.259 92.8435C106.809 93.6226 106.162 94.2695 105.383 94.7194C104.604 95.1692 103.72 95.406 102.821 95.406H5.17913C4.27952 95.406 3.39576 95.1692 2.61668 94.7194C1.8376 94.2695 1.19064 93.6226 0.740847 92.8435C0.29105 92.0644 0.0542545 91.1806 0.0542603 90.281C0.054266 89.3814 0.291073 88.4976 0.74088 87.7185L49.5616 3.15602C50.0115 2.37699 50.6584 1.73007 51.4375 1.2803C52.2166 0.830533 53.1003 0.59375 53.9999 0.59375C54.8995 0.59375 55.7832 0.830533 56.5623 1.2803C57.3413 1.73007 57.9883 2.37699 58.4381 3.15602ZM14.0556 85.156H93.9441L53.9999 15.9685L14.0556 85.156ZM48.8749 69.781H59.1249V80.031H48.8749V69.781ZM48.8749 33.906H59.1249V59.531H48.8749V33.906Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.2c77ea2f0d167f99138be2ddc2574dd4.svg";
export { ForwardRef as ReactComponent };